export default __webpack_public_path__ + "static/rpa-automation-procurement-1282a40f53dd5e50452218a3a7475af0.png";